import AsyncSelect from 'react-select/async';
import { MultiValue } from 'react-select';
import { SearchType } from '../../../data/__generated__/globalTypes';
import React, {ChangeEvent, useState} from 'react';
import { useForecastingSettings } from '../../ForecastingContextProvider';
import { usePrimaryForecastingState } from '../ForecastingPanel';
import { selectDefaults, useAutoCompleteOptions, useForecastingFilterValidation } from './ForecastingFilters';
import ErrorTooltip from '../ErrorTooltip';
import { ReactComponent as LoadingState } from 'svg/loader.svg';

export default function Zip() {
    const { forecastingSettings, updateForecastingSetting } = useForecastingSettings();
    const { isPrimaryForecastingLoading } = usePrimaryForecastingState();
    const loadOptions = useAutoCompleteOptions(SearchType.ZIP);
    const [textAreaValue, setTextAreaValue] = useState('');
    const [importEnabled, setImportEnabled] = useState(false);
    const { loading, data } = useForecastingFilterValidation(SearchType.ZIP);

    let tooltip = null;
    if (loading) {
        tooltip = <LoadingState className='inline-flex CampaignSpendOverlayLoadingState h-4 w-4 ml-1' />;
    } else {
        if (data?.filterDependencyValidation) {
            tooltip = (
                <ErrorTooltip id={'zip-error-tooltip'}>
                    <div>
                        The selected zips are no longer valid. They may be part of a country or region that is no longer selected.
                    </div>
                </ErrorTooltip>
            );
        }
    }
    
    const onChange = (newValue: MultiValue<{
        label: string,
        value: string
    }>) => updateForecastingSetting({ zipFilter: newValue.map(c => c.value) });
    
    return (
        <div className='mt-4 w-80'>
            <div style={{flexDirection: 'row'}}>
                <label
                    htmlFor='zip'
                    className='inline-block text-sm font-medium text-gray-700'
                >
                    Zip
                </label>
                {tooltip}
            </div>
            <AsyncSelect
                key={'zip:' + JSON.stringify(forecastingSettings)}
                isDisabled={isPrimaryForecastingLoading}
                menuPortalTarget={document.body}
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                isMulti
                name='zips'
                className='basic-multi-select'
                classNamePrefix='select'
                onChange={onChange}
                defaultOptions
                loadOptions={loadOptions}
                defaultValue={selectDefaults(forecastingSettings.zipFilter)}
            />
            <div style={{marginLeft: '16px'}}>
                <div>
                    Or <a
                        style={{textDecoration: 'underline', color: '#004FC2'}}
                        onClick = {() => {setImportEnabled(!importEnabled)}}>
                        paste zip list {importEnabled ? '▼' : '▶'}
                    </a>
                </div>
                <div style={importEnabled ? {display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'space-between'} : {display: 'none'}}>
                    <textarea
                        style={{width: '60%', fontSize: 'small'}}
                        onChange = {(event: ChangeEvent<HTMLTextAreaElement>) => {
                            setTextAreaValue(event.target.value);
                        }}
                    />
                    <button
                        onClick = {() => {
                            const newInput = textAreaValue.split(/[\t\n,;]+/).map(val => {
                                const trimmedVal = val.trim()
                                return {label: trimmedVal, value: trimmedVal}});
                            onChange(newInput);
                        }}
                    >
                        <label className={'bg-blue-700 text-white font-bold py-2 px-4 rounded'}>
                            Import
                        </label>
                    </button>
                </div>
            </div>
        </div>
    );
}
